// import React from "react";
// import SideBar from "./SideBar";

// export default function AppLayout({ children }) {
//   return (
//     <div className="flex h-screen">
//       <SideBar />
//       <main className="flex-1 relative bg-[#f5f7fa]">
//         {children}
//       </main>
//     </div>
//   );
// }

import React from "react";
//import SideBar from "./SideBar";

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-[#FAFAF6]">
      {/* <SideBar /> */}
      {/* min-w-0: a flex item defaults to min-width:auto, so this <main> refused to
          shrink below its content and grew to 1342px inside a 1140px parent, giving
          every page it wraps a page-level horizontal scrollbar. Measured before/after
          on /learning: 1342 -> 1152 (== innerWidth). */}
      <main className="flex-1 min-w-0 flex flex-col items-center justify-center bg-[#FAFAF6]">
        {children}
      </main>
    </div>
  );
}
